<template>
    <tr ref="thisTableRow">
        <td class="p-3">{{ tankCardMutation.tank_card.card_number }}</td>
        <td class="p-3 changes">
            <p v-for="changes in tankCardMutation.formattedChanges">{{ changes }}</p>
        </td>
        <td class="p-3">{{ tankCardMutation.similar_changes_count }}x</td>

        <td :class="{'p-3': isDeclined}">
            <template v-if="isDeclined">
                <input class="p-3 decline_reason"
                       type="text"
                       :name="`decline_reason[${tankCardMutation.id}]`"
                       placeholder="Reden afwijzing"
                       v-model="declineReason">
            </template>
        </td>

        <td class="icon-table">
            <span :class="{'btn-avia-icon cursor-pointer': true, 'active': isApproved}" @click="approve">
                <i class="fa fa-check"></i>
            </span>

            <input type="hidden" :name="`approved[${tankCardMutation.id}]`" :value="approved ? 1 : 0">
        </td>

        <td class="icon-table">
            <span :class="{'btn-avia-icon cursor-pointer': true, 'active': isDeclined}" @click="decline">
                <i class="fa fa-times"></i>
            </span>
        </td>

        <td class="reviewer-details">
            <div class="row">
                <div class="col-4">
                    <div>
                        <strong>Gebruiker ingevoerd:</strong> {{ tankCardMutation.created_by }}
                    </div>
                    <div class="mt-2">
                        <strong>Datum/tijd ingevoerd:</strong> {{ formatDateTime(tankCardMutation.created_at) }}
                    </div>
                </div>

            </div>
        </td>
    </tr>
</template>

<script>
    import moment from 'moment';

    export default {
    name: 'TankCardMutationsReviewalTableRow',

    props: {
        tankCardMutation: Object
    },

    data() {
        return {
            approved: null,
            declineReason: ''
        };
    },

    mounted() {
        let $tr = $(this.$refs.thisTableRow),
            totalHeight = $tr.find('.changes').outerHeight() + $tr.find('.reviewer-details').outerHeight();
        $tr.css('height', totalHeight + 'px');
    },

    computed: {
        isApproved() {
            return this.approved === true;
        },

        isDeclined() {
            return this.approved === false;
        },

        isReviewed() {
            return this.isApproved || this.declineReason.trim().length > 0;
        },

        changes(){
            return JSON.parse(this.tankCardMutation.changes || null);
        }
    },

    methods: {
        formatDateTime: (date) => (typeof date === 'object' ? date : moment(date)).format('DD/MM/YYYY HH:mm'),

        approve() {
            this.approved = true;
        },

        decline() {
            this.approved = false;
        }
    }
}
</script>

<style lang="scss" scoped>
    td.changes {
        p {
            margin-bottom: 0.5rem;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    td.reviewer-details {
        display: table-row-group;
        padding-bottom: 0.8rem;
        padding-left: 1rem;
        padding-right: 1rem;
        position: absolute;
        bottom: 0;
    }

    tr {
        position: relative;
    }

    input.decline_reason {
        width: 100%;
    }
</style>
